/**
 * Connection Status Indicator
 *
 * Shows real-time WebSocket connection status
 * - Green: Connected
 * - Yellow: Connecting/Reconnecting
 * - Red: Failed/Disconnected
 */

import { useRealtime } from '../../context/RealtimeContext';
import { ConnectionState } from '../../lib/RealtimeManager';
import './ConnectionStatus.css';

const ConnectionStatus = ({ showLabel = false, size = 'sm' }) => {
  const { connectionState, isConnected, isConnecting, connect } = useRealtime();

  const getStatusClass = () => {
    switch (connectionState) {
      case ConnectionState.CONNECTED:
        return 'status-connected';
      case ConnectionState.CONNECTING:
      case ConnectionState.RECONNECTING:
        return 'status-connecting';
      case ConnectionState.FAILED:
        return 'status-failed';
      default:
        return 'status-disconnected';
    }
  };

  const getStatusLabel = () => {
    switch (connectionState) {
      case ConnectionState.CONNECTED:
        return 'Live';
      case ConnectionState.CONNECTING:
        return 'Connecting...';
      case ConnectionState.RECONNECTING:
        return 'Reconnecting...';
      case ConnectionState.FAILED:
        return 'Offline';
      default:
        return 'Disconnected';
    }
  };

  const handleClick = () => {
    if (connectionState === ConnectionState.FAILED ||
        connectionState === ConnectionState.DISCONNECTED) {
      connect();
    }
  };

  return (
    <div
      className={`connection-status connection-status-${size} ${getStatusClass()}`}
      onClick={handleClick}
      title={`Real-time: ${getStatusLabel()}`}
      role="status"
      aria-label={`Connection status: ${getStatusLabel()}`}
    >
      <span className="status-indicator">
        {isConnecting && <span className="pulse-ring"></span>}
      </span>
      {showLabel && (
        <span className="status-label">{getStatusLabel()}</span>
      )}
    </div>
  );
};

export default ConnectionStatus;
